import { Helmet } from 'react-helmet-async';
import { filter, result } from 'lodash';
import { sentenceCase } from 'change-case';
import { useEffect, useState } from 'react';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  Modal,
  Box,
  Grid,
  List,
  ListItem,
  TextField,
  Divider,
  Radio,
  Select,
  OutlinedInput,
  InputLabel,
  Chip,
  InputAdornment
} from '@mui/material';
// import { Radio } from '@mui/joy';
import { ArrowBack, BlockOutlined, CancelOutlined, DeleteOutline, Update } from '@mui/icons-material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import { appApi } from 'src/apiUtils/AppApi';
import { url } from 'src/apiUtils/apiPath';
// components
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';

const TABLE_HEAD = [
  { id: 'user', label: 'User Name', alignHeader: false },
  { id: 'phone_number', label: 'Phone Number', alignHeader: false },
  { id: 'actions', label: 'Actions', alignHeader: false },
];



export default function UsersPage() {

  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);
  const [isLoading, setIsloading] = useState(false)

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [usersList, setUsersList] = useState([]);

  const [orderBy, setOrderBy] = useState('user.parnter_detail.user_name');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [studioUser, setstudioUser] = useState(true);

  const [userProfileDetail, setUserProfileDetail] = useState({
    "userPhone": "",
    "userName": "",
    "userId": "",
    "expertName": "",
    "description": "",
    "title": "",
    "avatarUrl": "",
    "file": "",
    "expertSkillLevel": "",
    "availableForSession": "",
    "language": [],


  })
  console.log('setUserProfileDetail', userProfileDetail);


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    handleUserList(newPage, rowsPerPage)
  };

  const handleChangeRowsPerPage = async (event) => {
    setRowsPerPage(event.target.value);
    handleUserList(0, event.target.value)
  };



  const [addEdit, setaddEdit] = useState(false)
  const [isEdit, setisEdit] = useState(false)
  const handleFormOpen = (id = null, action = '') => {
    setisEdit(action === 'edit')
    setaddEdit(addEdit !== true);
    if (id !== '' && id !== null) {
      appApi(`${url.STUDIO_USER_INFO}/${id}`, "GET", {}).then((result) => {
        console.log(result)
        if (result.data.length > 0) {
          setUserProfileDetail((pre) => ({
            ...pre,
            userId: id,
            expertName: result.data[0].userName ?? '',
            description: result.data[0].description ?? '',
            title: result.data[0].title ?? '',
            expertSkillLevel: result.data[0]?.skillExperienceLevel?._id ?? '',
            availableForSession: result.data[0].availableForSession ?? '',
            userPhone: result.data[0]?.users[0]?.userPhone,
            userName: result.data[0]?.userDetail[0]?.userName,
            language: Object.values(result.data[0].expertLanguage.map((e) => {
              return e._id
            }))
          }))
        } else {
          setUserProfileDetail((pre) => ({
            ...pre,
            userPhone: '',
            userName: '',
            userId: id,
            expertName: '',
            description: '',
            title: '',
            expertSkillLevel: '',
            availableForSession: '',
            language: []
          }))
        }

      })
    } else {
      setUserProfileDetail((pre) => ({
        ...pre,
        userPhone: '',
        userName: '',
        userId: id,
        expertName: '',
        description: '',
        title: '',
        expertSkillLevel: '',
        availableForSession: '',
        language: []
      }))
    }
    console.log(userProfileDetail);
  };
  const [languageList, setlanguageList] = useState([])

  const [sessionList, setsessionList] = useState([])

  const [expertLevelList, setexpertLevelList] = useState([])

  const [userType, setUserType] = useState(2)
  useEffect(() => {
    appApi(url.LANGUAGE_LIST, "GET", {}).then((result) => {
      console.log(result)
      if (result.data.Languages.length > 0) {
        setlanguageList(result.data.Languages)
        setsessionList(result.data.availableForSession)
      } else {
        setlanguageList([])
        setsessionList([])
      }
    })
    appApi(url.EXPERT_LEVEL_LIST, "GET", {}).then((result) => {
      console.log(result)
      if (result.data.length > 0) {
        setexpertLevelList(result.data)
      } else {
        setexpertLevelList([])
      }
    })
    // appApi(`${url.STUDIO_USER_LIST}/${userType}`, "GET", {}).then((result) => {
    //   console.log(result)
    //   if (result.data.length > 0) {
    //     setUsersList(result.data)
    //   } else {
    //     setUsersList([])
    //   }

    // })
    handleUserList(0, 5)
  }, [])

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };


  const handleCreateUser = () => {
    const data = {
      ...userProfileDetail
    }
    const formData = new FormData();
    const keys = Object.keys(data);
    keys.forEach((e) => {
      if (e === "language") {
        data[e].forEach((ln, i) => {
          console.log(`${e}[]`, data[e] ? data[e][i] : '')
          formData.append(`${e}[]`, data[e] ? data[e][i] : '')
        })
      }
      else {
        console.log(e, data[e])
        formData.append(e, data[e])
      }
    })
    appApi(url.STUDIO_USER_CREATE, "POST", {}, formData)
      .then((result) => {
      })
  }


  const [userListCount, setUserListCount] = useState(0);
  const handleUserList = (pages, rows) => {
    // setUserType(event.target.value)
    setPage(pages);
    setRowsPerPage(rows)
    appApi(`${url.STUDIO_USER_LIST}/${userType}?limit=${rows}&page=${pages + 1}`, "GET", { params: { page, limit: rowsPerPage } }).then((result) => {
      console.log(result)
      if (result.data.expertDtlProf.length > 0) {
        console.log('restultdata', result.data);
        setUsersList(result.data.expertDtlProf)
        setUserListCount(result.data?.count[0]?.count)
      } else {
        setUsersList([])
        setUserListCount(0)
      }

    })
  }

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - userListCount) : 0;

  return (
    <>
      <Helmet>
        <title> Users Management  </title>
      </Helmet>

      < Container maxWidth="xl">
        <Card sx={{ padding: 2, marginBottom: 3 }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Box sx={{ paddingTop: 1 }}>
              <Typography variant="h4" gutterBottom>
                Users Management
              </Typography>
            </Box>
            {addEdit ?
              <Button variant="contained" startIcon={addEdit ? <ArrowBack /> : <Iconify icon="eva:plus-fill" />} sx={{
                backgroundColor: "action.selected", '&:hover': {
                  backgroundColor: "action.selected",
                }
              }}
                onClick={() => {
                  handleFormOpen()
                }} >
                {"Back"}
              </Button> : <>
                {/* <TextField
                  select
                  name="userType"
                  value={userType}
                  sx={{ width: '20%' }}
                  onChange={handleUserList}
                >
                  <MenuItem value={1}>{'Studio User'}</MenuItem>
                  <MenuItem value={2}>{'User'}</MenuItem>
                </TextField> */}
                {/* <Button variant="contained" startIcon={addEdit ? <ArrowBack /> : <Iconify icon="eva:plus-fill" />} sx={{
                  backgroundColor: "action.selected", '&:hover': {
                    backgroundColor: "action.selected",
                  }
                }}
                  onClick={() => {
                    handleFormOpen()
                  }} >
                  {"Add Users"}
                </Button> */}
              </>}
          </Stack>
        </Card>
        <Card>
          {addEdit ?
            <>
              <Box>
                <Box sx={{ padding: 5 }}>
                  <List>
                    <ListItem>
                      <TextField
                        fullWidth
                        label={"Enter User Name"}
                        name="user_name"
                        placeholder='Enter your name'
                        value={userProfileDetail.userName}
                        onChange={(event) => {
                          setUserProfileDetail((pre) => ({
                            ...pre,
                            userName: event.target.value
                          }))
                        }}
                        sx={{ marginRight: 1 }}
                      />
                      <TextField
                        fullWidth
                        label={"Enter Display Name"}
                        name="user_name"
                        placeholder='Enter your name'
                        value={userProfileDetail.expertName}
                        onChange={(event) => {
                          setUserProfileDetail((pre) => ({
                            ...pre,
                            expertName: event.target.value
                          }))
                        }}
                        sx={{ marginLeft: 1 }}
                      />
                    </ListItem>
                    <ListItem>
                      <TextField
                        fullWidth
                        label={"Phone Number"}
                        name="userPhone"
                        value={userProfileDetail.userPhone}
                        inputProps={{
                          maxLength: 10,
                        }}
                        onChange={(event) => {
                          setUserProfileDetail((pre) => ({
                            ...pre,
                            userPhone: event.target.value
                          }))
                        }}
                        sx={{ marginRight: 1 }}
                      />
                      <TextField
                        fullWidth
                        label={"Sub Title / Caption"}
                        name="sub_title"
                        value={userProfileDetail.title}
                        onChange={(event) => {
                          setUserProfileDetail((pre) => ({
                            ...pre,
                            title: event.target.value
                          }))
                        }}
                        sx={{ marginLeft: 1 }}
                      />
                    </ListItem>
                    <ListItem>
                      <TextField
                        select
                        fullWidth
                        label={"Genre"}
                        name="skillExperienceLevel"
                        value={userProfileDetail.expertSkillLevel}
                        onChange={(event) => {
                          setUserProfileDetail((pre) => ({
                            ...pre,
                            expertSkillLevel: event.target.value
                          }))
                        }}
                        sx={{ marginRight: 1 }}
                      >
                        <MenuItem key={''} value={''}>{expertLevelList?.length > 0 ? 'Choose your Genre' : 'None'}</MenuItem>

                        {expertLevelList?.length > 0 ? expertLevelList.map((e) => (
                          <MenuItem key={e._id} value={e._id}>{e.level}</MenuItem>
                        )) : <></>
                        }
                      </TextField>
                      <TextField
                        labelId="user_language"
                        id="user_language"
                        select
                        fullWidth
                        label="Choose Your Language"
                        SelectProps={{
                          multiple: true,
                          value: userProfileDetail.language,
                          onChange: (event) => {
                            setUserProfileDetail((pre) => ({
                              ...pre,
                              language: event.target.value
                            }))
                          },
                          renderValue: (selected) => {
                            selected.map((value) => (
                              value
                            ))
                          }
                        }}
                        sx={{ marginLeft: 1 }
                        }
                      >
                        {languageList?.length > 0 ? languageList.map((e) => (
                          <MenuItem key={e._id} value={e._id}>{e.language}</MenuItem>
                        )) : <><MenuItem key={''} value={''}>{'None'}</MenuItem></>
                        }
                      </TextField>
                    </ListItem>

                    <ListItem>
                      <TextField
                        select
                        fullWidth
                        label={"Available for session?"}
                        name="user_session"
                        value={userProfileDetail.availableForSession}
                        onChange={(event) => {
                          setUserProfileDetail((pre) => ({
                            ...pre,
                            availableForSession: event.target.value
                          }))
                        }}
                        sx={{ marginRight: 1 }}
                      >
                        <MenuItem key={''} value={''}>{sessionList?.length > 0 ? 'Choose your availability' : 'None'}</MenuItem>

                        {sessionList?.length > 0 ? sessionList.map((e) => (
                          <MenuItem key={e} value={e}>{e}</MenuItem>
                        )) : <></>
                        }
                      </TextField>
                      <TextField
                        fullWidth
                        type="file"
                        onChange={(event) => {
                          console.log(event.target.files[0])

                          setUserProfileDetail((pre) => ({
                            ...pre,
                            file: event.target.files[0]
                          }))
                        }}
                        sx={{ marginLeft: 1 }}
                      />
                    </ListItem>
                    <ListItem>
                      <TextField
                        fullWidth
                        multiline
                        label={"Introduction"}
                        name="introduction"
                        rows={4}

                        placeholder='Enter Some details'
                        value={userProfileDetail.description}
                        onChange={(event) => {
                          setUserProfileDetail((pre) => ({
                            ...pre,
                            description: event.target.value
                          }))
                        }}

                      />
                    </ListItem>

                    <ListItem
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: 2
                      }}
                    >
                      <Button
                        sx={{
                          color: "white",
                          paddingLeft: "10%",
                          paddingRight: "10%",
                          width: "10%",
                          height: "20%",
                          "&:hover": {
                            backgroundColor: "button.theme"
                          },
                          bgcolor: "button.theme",

                        }}
                        onClick={() => {
                          handleCreateUser()
                        }}>
                        {'Submit'}
                      </Button>
                    </ListItem>
                  </List>


                </Box>
              </Box> </> : <>    <Box sx={{ padding: 1 }}>
                {/* <Stack alignItems="end" justifyContent="flex-end">
                  <UserListToolbar title={'Studio User'} />
                </Stack> */}
                <Scrollbar>
                  <TableContainer sx={{ minWidth: 800 }}>
                    <Table>
                      <UserListHead
                        order={order}
                        orderBy={orderBy}
                        headLabel={TABLE_HEAD}
                        rowCount={userListCount}
                        onRequestSort={handleRequestSort}
                      />
                      <TableBody>
                        {/* slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage). */}
                        {usersList.map((user) => (
                          <TableRow key={user._id}>

                            <TableCell align="left">{user?.userName ?? '--'}</TableCell>
                            <TableCell align="left">{user?.userPhone ?? '--'}</TableCell>


                            <TableCell align="left">


                              <Button variant="contained" startIcon={<Iconify icon={'eva:slash-outline'} />}
                                sx={{
                                  backgroundColor: "#D11A2A", '&:hover': {
                                    backgroundColor: "#D11A2A"
                                  },
                                }}
                              >
                                {"Block"}
                              </Button>
                              <Button variant="contained" startIcon={<Iconify icon={'eva:trash-outline'} />} sx={{
                                backgroundColor: "#D11A2A", '&:hover': {
                                  backgroundColor: "#D11A2A"
                                },
                                marginLeft: 1
                              }}
                              >
                                {"Delete"}
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))}
                        {emptyRows > 0 && (
                          <TableRow style={{ height: 53 * emptyRows }}>
                            <TableCell colSpan={6} />
                          </TableRow>
                        )}
                      </TableBody>
                      {usersList && usersList.length === 0 && (
                        <TableBody>
                          <TableRow>
                            <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                              <Paper
                                sx={{
                                  textAlign: 'center',
                                }}
                              >
                                <Typography variant="h6" paragraph color={'red'}>
                                  {isLoading ? 'Loading .....' : 'No Data Found'}
                                </Typography>
                              </Paper>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      )}
                    </Table>
                  </TableContainer>
                </Scrollbar>
                {userListCount >rowsPerPage ? 
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={userListCount}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                /> : <></>}
              </Box></>}

        </Card>
      </Container >
      <ToastContainer />

    </>
  );
}
